import {trackAmplitudeNavigationClick} from "../../navigation/tracking/track_amplitude_navigation_click";

export const trackFavouritesIconClick = () => {
    trackAmplitudeNavigationClick("rp_favourites", undefined, "Ulubione");
};
import {trackAmplitudeNavigationClick} from "../../navigation/tracking/track_amplitude_navigation_click";

export const trackFavouritesIconClick = () => {
    trackAmplitudeNavigationClick("rp_favourites", undefined, "Ulubione");
};
